import { makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
  mainContainer: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    paddingTop: '10em',
  },
  title: {
    textAlign: 'center',
    color: theme.palette.info.dark,
  },
  button: {
    backgroundColor: theme.palette.success.main,
    margin: theme.spacing(1),
    color: 'white',
    fontSize: '1.5rem',
    paddingRight: theme.spacing(5),
    paddingLeft: theme.spacing(5),
  },
}));
